import React from 'react';
import { FormattedMessage } from 'react-intl';

type Props = {
  cell: Record<string, any>;
};

const index = (props: Props) => {
  const { cell } = props;
  const rollback = cell?.value || cell?.row?.original?.patchUninstallable;
  return (
    <div>
      <FormattedMessage id={`${rollback ? 'common.yes' : 'common.no'}`} />
    </div>
  );
};

export default index;
